import { useMemo } from 'react';
import sortBy from 'lodash/sortBy';

import { ViewProps } from './response.constants';
import { SubActivityEdit } from '../sub-activity/sub-activity-edit';
import { useResponseBaseHeight } from './response.hooks';
import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import * as Styled from './response-edit.style';

const ResponseEdit = ({
  id,
  properties,
  sectionId,
  type,
  sort,
  subActivityProperties,
  version,
}: ViewProps) => {
  const { editModeTargetElement } = useActivityBuilderContext();
  const baseHeight = useResponseBaseHeight();

  const sortedFields = useMemo(
    () => sortBy(properties.textResponse.fields, 'sort'),
    [properties.textResponse.fields]
  );

  return (
    <SubActivityEdit
      id={id}
      component={{
        id,
        type,
        sort,
        properties,
        sectionId,
        language: null,
        version,
        __typename: 'ActivitiesResponseComponent',
      }}
      subActivityDetails={subActivityProperties}
    >
      {() => (
        <Styled.ResponseContainer>
          {sortedFields.map(field => {
            return (
              <Styled.ResponseBox
                key={field.itemId}
                $isInEditFocus={editModeTargetElement === field.itemId}
                $baseColour={field.baseColour}
              >
                <Styled.ResponseEditField
                  $numberOfLines={field.numberOfLines || 1}
                  $baseHeight={baseHeight}
                  $isScaffoldedPlaceholder={!!field.isPlaceholderScaffold}
                  data-selector="response-edit-field"
                >
                  {field.placeholder || ''}
                </Styled.ResponseEditField>
              </Styled.ResponseBox>
            );
          })}
        </Styled.ResponseContainer>
      )}
    </SubActivityEdit>
  );
};

export default ResponseEdit;
